import { createRoleUseCase } from '@src/main/modules/roles/application/create-role.usecase';
import { CreateUpdateRoleRequest } from '@src/main/modules/roles/infrastructure/dto/createUpdateUserRequest';
import { createRoleHttpRepository } from '@src/main/modules/roles/infrastructure/RoleHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useCreateRole = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createRoleHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (data: CreateUpdateRoleRequest) => {
      if (!repository) throw new Error('Repository not initialized');
      return await createRoleUseCase(data, tokenProvider);
    },
  });
};
